export default (template, data) => {
    if (!data) {
        return "";
    }
    const keys = Object.keys(data);
    const values = Object.values(data);
    const finalString = keys.reduce((acc, currentValue, index) => {
        return acc.replace(new RegExp(`{${currentValue}}`, "g"), values[index]);
    }, (template || ""));
    return finalString;
};
